import { useState } from "react";

const CONTACT_EMAIL =
  "akshayprajapati2897@gmail.com";

const GITHUB_URL =
  "https://github.com/akshayecs";

const LINKEDIN_URL =
  "https://www.linkedin.com/";

const socialLinks = [
  {
    name: "Email",
    shortName: "Gmail",
    href: `mailto:${CONTACT_EMAIL}`,
    className: "contact-social-email",
    external: false,
    icon: (
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M3 5.5h18v13H3z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />

        <path
          d="m4 7 8 6 8-6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },

  {
    name: "GitHub",
    shortName: "GitHub",
    href: GITHUB_URL,
    className: "contact-social-github",
    external: true,
    icon: (
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          fill="currentColor"
          d="M12 .7a11.3 11.3 0 0 0-3.58 22.02c.57.1.78-.25.78-.55v-2.16c-3.18.69-3.85-1.34-3.85-1.34-.52-1.33-1.27-1.69-1.27-1.69-1.04-.71.08-.7.08-.7 1.15.08 1.75 1.18 1.75 1.18 1.03 1.76 2.69 1.25 3.35.96.1-.75.4-1.25.73-1.54-2.54-.29-5.21-1.27-5.21-5.66 0-1.25.45-2.27 1.18-3.07-.12-.29-.51-1.45.11-3.03 0 0 .97-.31 3.12 1.17a10.8 10.8 0 0 1 5.68 0c2.15-1.48 3.12-1.17 3.12-1.17.62 1.58.23 2.74.11 3.03.73.8 1.18 1.82 1.18 3.07 0 4.4-2.67 5.36-5.22 5.64.41.35.78 1.04.78 2.1v3.11c0 .3.21.65.79.55A11.3 11.3 0 0 0 12 .7Z"
        />
      </svg>
    ),
  },

  {
    name: "LinkedIn",
    shortName: "LinkedIn",
    href: LINKEDIN_URL,
    className: "contact-social-linkedin",
    external: true,
    icon: (
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          fill="currentColor"
          d="M5.1 3.2a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2ZM3.3 9h3.6v11.7H3.3V9Zm5.8 0h3.4v1.6h.05c.47-.9 1.62-1.85 3.34-1.85 3.57 0 4.23 2.35 4.23 5.41v6.54h-3.56v-5.8c0-1.38-.03-3.15-1.92-3.15-1.93 0-2.23 1.5-2.23 3.05v5.9H9.1V9Z"
        />
      </svg>
    ),
  },
];

export default function Contact() {
  const [submitted, setSubmitted] =
    useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (event) => {
    const {
      name,
      value,
    } = event.target;

    setForm((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const subject =
      encodeURIComponent(
        `Portfolio Contact from ${form.name}`
      );

    const body =
      encodeURIComponent(
        `Name: ${form.name}\n` +
        `Email: ${form.email}\n\n` +
        `Message:\n${form.message}`
      );

    window.location.href =
      `mailto:${CONTACT_EMAIL}` +
      `?subject=${subject}` +
      `&body=${body}`;

    setSubmitted(true);
  };

  return (
    <section
      id="contact"
      className="section contact-section"
    >
      <div className="container">

        <div className="contact-layout">

          {/* LEFT SIDE */}

          <div className="contact-copy">

            <p className="section-kicker">
              Get in touch
            </p>

            <h2>
              Let's build
              <br />
              something useful.
            </h2>

            <p>
              Have a backend challenge, product
              idea or Node.js opportunity? Send
              me a message and your email client
              will open with the details.
            </p>

            {/* SOCIAL CONNECTION */}

            <div className="connect-block">

              <p className="connect-title">
                Let's connect
              </p>

              <div className="connect-socials">

                {socialLinks.map(
                  (social) => (
                    <a
                      key={social.name}
                      href={social.href}
                      className={`connect-social ${social.className}`}
                      aria-label={`Connect with me on ${social.name}`}
                      title={social.name}
                      target={
                        social.external
                          ? "_blank"
                          : undefined
                      }
                      rel={
                        social.external
                          ? "noopener noreferrer"
                          : undefined
                      }
                    >

                      <span className="social-icon">
                        {social.icon}
                      </span>

                      <span className="social-label">
                        {social.shortName}
                      </span>

                    </a>
                  )
                )}

              </div>

            </div>

          </div>

          {/* CONTACT FORM */}

          <div className="contact-card">

            {!submitted ? (
              <form
                onSubmit={handleSubmit}
              >

                <div className="form-row">

                  <label>
                    Name

                    <input
                      type="text"
                      name="name"
                      placeholder="Your name"
                      value={form.name}
                      onChange={handleChange}
                      autoComplete="name"
                      required
                    />
                  </label>

                  <label>
                    Email

                    <input
                      type="email"
                      name="email"
                      placeholder="you@example.com"
                      value={form.email}
                      onChange={handleChange}
                      autoComplete="email"
                      required
                    />
                  </label>

                </div>

                <label>
                  Message

                  <textarea
                    name="message"
                    rows="6"
                    placeholder="Tell me a little about your project or opportunity..."
                    value={form.message}
                    onChange={handleChange}
                    required
                  />
                </label>

                <button
                  type="submit"
                  className="button button-primary submit-button"
                >

                  <span
                    className="button-icon"
                    aria-hidden="true"
                  >
                    ✉
                  </span>

                  Open Email App

                  <span aria-hidden="true">
                    ↗
                  </span>

                </button>

                <p className="form-note">
                  No data is stored by this form.
                  It uses your device's mail client.
                </p>

              </form>
            ) : (
              <div className="success-state">

                <div className="success-icon">
                  ✓
                </div>

                <h3>
                  Your email is ready.
                </h3>

                <p>
                  Your mail application should
                  have opened with the message
                  details.
                </p>

                <button
                  type="button"
                  className="button button-secondary"
                  onClick={() => {
                    setSubmitted(false);

                    setForm({
                      name: "",
                      email: "",
                      message: "",
                    });
                  }}
                >
                  Send another message
                </button>

              </div>
            )}

          </div>

        </div>

      </div>
    </section>
  );
}